import { OnDestroy } from '@angular/core';
import { Component, AfterViewInit } from '@angular/core';

const BODY_CSSCLASS = "bg-image-none";
const MAIN_CSSCLASS = "bg-image-dummy";

@Component({
    selector: 'app-dummy-component',
    templateUrl: './_dummy.html',
    styleUrls: ['./_dummy.scss'],
    standalone: true
})

export class AppDummyComponent implements AfterViewInit, OnDestroy {
  ngAfterViewInit() {
    setTimeout(() => {
      document.querySelector("body")?.classList.add(BODY_CSSCLASS);
      document.querySelector("main.main")?.classList.add(MAIN_CSSCLASS);
    });
  }

  ngOnDestroy() {
    document.querySelector("body")?.classList.remove(BODY_CSSCLASS);
    document.querySelector("main.main")?.classList.remove(MAIN_CSSCLASS);
  }
}
